//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class BackgroundJobClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    executeBackgroundJob(command: ExecuteBackgroundJobCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/BackgroundJob/ExecuteBackgroundJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteBackgroundJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteBackgroundJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExecuteBackgroundJob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshRegistration(command: RefreshRegistrationCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BackgroundJob/RefreshRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRefreshRegistration(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BlobClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    uploadBlob(file: FileParameter | null | undefined, name: string | null | undefined, type: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Blob/UploadBlob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (type !== null && type !== undefined)
            content_.append("Type", type.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadBlob(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBlobContent(id: string | undefined, type: BlobType | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Blob/GetBlobContent?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlobContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlobContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetBlobContent(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EntityMappingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPrefilledRecord(getPrefilledRecordQuery: GetPrefilledRecordQuery): Observable<{ [key: string]: any; }> {
        let url_ = this.baseUrl + "/api/EntityMapping/GetPrefilledRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getPrefilledRecordQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrefilledRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrefilledRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: any; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: any; }>;
        }));
    }

    protected processGetPrefilledRecord(response: HttpResponseBase): Observable<{ [key: string]: any; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMappingOperations(getMappingOperationsQuery: GetMappingOperationsQuery): Observable<GetMappingOperationsQueryResult> {
        let url_ = this.baseUrl + "/api/EntityMapping/GetMappingOperations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getMappingOperationsQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMappingOperations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMappingOperations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMappingOperationsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMappingOperationsQueryResult>;
        }));
    }

    protected processGetMappingOperations(response: HttpResponseBase): Observable<GetMappingOperationsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMappingOperationsQueryResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ImportExportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    exportRecords(fileType: FileType | undefined, viewId: string | undefined, additionalQuery: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ImportExport/ExportRecords?";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        if (viewId === null)
            throw new Error("The parameter 'viewId' cannot be null.");
        else if (viewId !== undefined)
            url_ += "ViewId=" + encodeURIComponent("" + viewId) + "&";
        if (additionalQuery !== undefined && additionalQuery !== null)
            url_ += "AdditionalQuery=" + encodeURIComponent("" + additionalQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportRecords(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportImportTemplate(fileType: FileType | undefined, viewId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ImportExport/ExportImportTemplate?";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        if (viewId === null)
            throw new Error("The parameter 'viewId' cannot be null.");
        else if (viewId !== undefined)
            url_ += "ViewId=" + encodeURIComponent("" + viewId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportImportTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportImportTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportImportTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportForReimport(fileType: FileType | undefined, viewId: string | undefined, additionalQuery: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ImportExport/ExportForReimport?";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        if (viewId === null)
            throw new Error("The parameter 'viewId' cannot be null.");
        else if (viewId !== undefined)
            url_ += "ViewId=" + encodeURIComponent("" + viewId) + "&";
        if (additionalQuery !== undefined && additionalQuery !== null)
            url_ += "AdditionalQuery=" + encodeURIComponent("" + additionalQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportForReimport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportForReimport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportForReimport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocalizationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    languages(): Observable<LanguageDto[]> {
        let url_ = this.baseUrl + "/api/Localization/Languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageDto[]>;
        }));
    }

    protected processLanguages(response: HttpResponseBase): Observable<LanguageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uILanguages(): Observable<UILanguageDto[]> {
        let url_ = this.baseUrl + "/api/Localization/UILanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUILanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUILanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UILanguageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UILanguageDto[]>;
        }));
    }

    protected processUILanguages(response: HttpResponseBase): Observable<UILanguageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UILanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    infrastructureTranslations(language: string | null | undefined): Observable<{ [key: string]: { [key: string]: string; }; }> {
        let url_ = this.baseUrl + "/api/Localization/InfrastructureTranslations?";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfrastructureTranslations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfrastructureTranslations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: { [key: string]: string; }; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: { [key: string]: string; }; }>;
        }));
    }

    protected processInfrastructureTranslations(response: HttpResponseBase): Observable<{ [key: string]: { [key: string]: string; }; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : {};
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NavigationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getUserViewSettingsNavigationInfo(viewId: string): Observable<UserViewSettingsNavigationInfoDto> {
        let url_ = this.baseUrl + "/api/Navigation/GetUserViewSettingsNavigationInfo/{viewId}";
        if (viewId === undefined || viewId === null)
            throw new Error("The parameter 'viewId' must be defined.");
        url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserViewSettingsNavigationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserViewSettingsNavigationInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewSettingsNavigationInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewSettingsNavigationInfoDto>;
        }));
    }

    protected processGetUserViewSettingsNavigationInfo(response: HttpResponseBase): Observable<UserViewSettingsNavigationInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewSettingsNavigationInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNavigationTargets(navigationTokens: string[] | null | undefined): Observable<GetNavigationTargetsQueryResult> {
        let url_ = this.baseUrl + "/api/Navigation/GetNavigationTargets?";
        if (navigationTokens !== undefined && navigationTokens !== null)
            navigationTokens && navigationTokens.forEach(item => { url_ += "navigationTokens=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNavigationTargets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNavigationTargets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNavigationTargetsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNavigationTargetsQueryResult>;
        }));
    }

    protected processGetNavigationTargets(response: HttpResponseBase): Observable<GetNavigationTargetsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNavigationTargetsQueryResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createNavigationTarget(command: CreateNavigationTargetCommand): Observable<NavigationTargetDto> {
        let url_ = this.baseUrl + "/api/Navigation/CreateNavigationTarget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNavigationTarget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNavigationTarget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NavigationTargetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NavigationTargetDto>;
        }));
    }

    protected processCreateNavigationTarget(response: HttpResponseBase): Observable<NavigationTargetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NavigationTargetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PermissionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    checkCurrentUserPermissionKey(permissionKeyId: string | undefined): Observable<CheckCurrentUserPermissionKeyResult> {
        let url_ = this.baseUrl + "/api/Permission/CheckCurrentUserPermissionKey?";
        if (permissionKeyId === null)
            throw new Error("The parameter 'permissionKeyId' cannot be null.");
        else if (permissionKeyId !== undefined)
            url_ += "PermissionKeyId=" + encodeURIComponent("" + permissionKeyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCurrentUserPermissionKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCurrentUserPermissionKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckCurrentUserPermissionKeyResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckCurrentUserPermissionKeyResult>;
        }));
    }

    protected processCheckCurrentUserPermissionKey(response: HttpResponseBase): Observable<CheckCurrentUserPermissionKeyResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckCurrentUserPermissionKeyResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ResourceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    webResources(name: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Resource/WebResources/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWebResources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebResources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processWebResources(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SearchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDataItem(entityName: string | null | undefined, filter: string | null | undefined, translatedProperties: string[] | null | undefined): Observable<KeyValuePairOfStringAndObject[][]> {
        let url_ = this.baseUrl + "/api/Search/GetDataItem?";
        if (entityName !== undefined && entityName !== null)
            url_ += "entityName=" + encodeURIComponent("" + entityName) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (translatedProperties !== undefined && translatedProperties !== null)
            translatedProperties && translatedProperties.forEach(item => { url_ += "translatedProperties=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValuePairOfStringAndObject[][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValuePairOfStringAndObject[][]>;
        }));
    }

    protected processGetDataItem(response: HttpResponseBase): Observable<KeyValuePairOfStringAndObject[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SystemClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEngineVersion(): Observable<EngineVersion> {
        let url_ = this.baseUrl + "/api/System/GetEngineVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEngineVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEngineVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EngineVersion>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EngineVersion>;
        }));
    }

    protected processGetEngineVersion(response: HttpResponseBase): Observable<EngineVersion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EngineVersion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getUserProfile(): Observable<UserProfileDto> {
        let url_ = this.baseUrl + "/api/User/GetUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileDto>;
        }));
    }

    protected processGetUserProfile(response: HttpResponseBase): Observable<UserProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserViewSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    setUserViewSettingsPageSize(command: SetUserViewSettingsPageSizeCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/UserViewSettings/SetUserViewSettingsPageSize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserViewSettingsPageSize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserViewSettingsPageSize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSetUserViewSettingsPageSize(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setUserViewSettingsMainSelectorVisibility(command: SetUserViewSettingsMainSelectorVisibilityCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/UserViewSettings/SetUserViewSettingsMainSelectorVisibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserViewSettingsMainSelectorVisibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserViewSettingsMainSelectorVisibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSetUserViewSettingsMainSelectorVisibility(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserViewSettingsMainSelectorVisibility(entityId: string | undefined): Observable<ViewMainSelectorVisibilityDto[]> {
        let url_ = this.baseUrl + "/api/UserViewSettings/GetUserViewSettingsMainSelectorVisibility?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserViewSettingsMainSelectorVisibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserViewSettingsMainSelectorVisibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewMainSelectorVisibilityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewMainSelectorVisibilityDto[]>;
        }));
    }

    protected processGetUserViewSettingsMainSelectorVisibility(response: HttpResponseBase): Observable<ViewMainSelectorVisibilityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewMainSelectorVisibilityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ViewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEntityView(location: ViewTargets, viewId: string): Observable<EntityViewDto> {
        let url_ = this.baseUrl + "/api/View/GetEntityView/{location}/{viewId}";
        if (location === undefined || location === null)
            throw new Error("The parameter 'location' must be defined.");
        url_ = url_.replace("{location}", encodeURIComponent("" + location));
        if (viewId === undefined || viewId === null)
            throw new Error("The parameter 'viewId' must be defined.");
        url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityViewDto>;
        }));
    }

    protected processGetEntityView(response: HttpResponseBase): Observable<EntityViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getErrorHandlers(exceptionName: string | null | undefined): Observable<ErrorHandlerDto[]> {
        let url_ = this.baseUrl + "/api/ErrorHandler/GetErrorHandlers?";
        if (exceptionName !== undefined && exceptionName !== null)
            url_ += "exceptionName=" + encodeURIComponent("" + exceptionName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErrorHandlers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErrorHandlers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErrorHandlerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErrorHandlerDto[]>;
        }));
    }

    protected processGetErrorHandlers(response: HttpResponseBase): Observable<ErrorHandlerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ErrorHandlerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProcessesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getProcessStateWithTransitions(processStateId: string | undefined): Observable<ProcessStateDto> {
        let url_ = this.baseUrl + "/api/Processes/GetProcessStateWithTransitions?";
        if (processStateId === null)
            throw new Error("The parameter 'processStateId' cannot be null.");
        else if (processStateId !== undefined)
            url_ += "processStateId=" + encodeURIComponent("" + processStateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessStateWithTransitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessStateWithTransitions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessStateDto>;
        }));
    }

    protected processGetProcessStateWithTransitions(response: HttpResponseBase): Observable<ProcessStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessStateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProcessAssignmentsForEntity(entityId: string | undefined): Observable<ProcessEntityAssignmentDto[]> {
        let url_ = this.baseUrl + "/api/Processes/GetProcessAssignmentsForEntity?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessAssignmentsForEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessAssignmentsForEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessEntityAssignmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessEntityAssignmentDto[]>;
        }));
    }

    protected processGetProcessAssignmentsForEntity(response: HttpResponseBase): Observable<ProcessEntityAssignmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessEntityAssignmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    executeProcessTransition(command: ExecuteProcessTransitionCommand): Observable<ProcessExecutionResult> {
        let url_ = this.baseUrl + "/api/Processes/ExecuteProcessTransition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteProcessTransition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteProcessTransition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessExecutionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessExecutionResult>;
        }));
    }

    protected processExecuteProcessTransition(response: HttpResponseBase): Observable<ProcessExecutionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessExecutionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProcessHistory(processAssignmentId: string | undefined, recordId: string | undefined): Observable<ProcessInstanceHistoryDto[]> {
        let url_ = this.baseUrl + "/api/Processes/GetProcessHistory?";
        if (processAssignmentId === null)
            throw new Error("The parameter 'processAssignmentId' cannot be null.");
        else if (processAssignmentId !== undefined)
            url_ += "processAssignmentId=" + encodeURIComponent("" + processAssignmentId) + "&";
        if (recordId === null)
            throw new Error("The parameter 'recordId' cannot be null.");
        else if (recordId !== undefined)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessInstanceHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessInstanceHistoryDto[]>;
        }));
    }

    protected processGetProcessHistory(response: HttpResponseBase): Observable<ProcessInstanceHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessInstanceHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetProcess(command: ResetProcessCommand): Observable<ProcessExecutionResult> {
        let url_ = this.baseUrl + "/api/Processes/ResetProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessExecutionResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessExecutionResult>;
        }));
    }

    protected processResetProcess(response: HttpResponseBase): Observable<ProcessExecutionResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessExecutionResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MenuClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getMainMenu(): Observable<MainMenuDto> {
        let url_ = this.baseUrl + "/api/Menu/GetMainMenu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMainMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMainMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MainMenuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MainMenuDto>;
        }));
    }

    protected processGetMainMenu(response: HttpResponseBase): Observable<MainMenuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MainMenuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addMenuItemToFavorite(command: AddMenuItemToFavoriteCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Menu/AddMenuItemToFavorite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMenuItemToFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMenuItemToFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAddMenuItemToFavorite(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addMenuItemToRecent(command: AddMenuItemToRecentCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Menu/AddMenuItemToRecent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMenuItemToRecent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMenuItemToRecent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAddMenuItemToRecent(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeMenuItemFromFavorite(command: RemoveMenuItemFromFavoriteCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Menu/RemoveMenuItemFromFavorite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveMenuItemFromFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveMenuItemFromFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRemoveMenuItemFromFavorite(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class KanbanClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEntityKanban(kanbanId: string): Observable<KanbanDto> {
        let url_ = this.baseUrl + "/api/Kanban/GetEntityKanban/{kanbanId}";
        if (kanbanId === undefined || kanbanId === null)
            throw new Error("The parameter 'kanbanId' must be defined.");
        url_ = url_.replace("{kanbanId}", encodeURIComponent("" + kanbanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityKanban(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityKanban(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KanbanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KanbanDto>;
        }));
    }

    protected processGetEntityKanban(response: HttpResponseBase): Observable<KanbanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KanbanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    recalculateRecordsStackRank(kanbanId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Kanban/RecalculateRecordsStackRank/{kanbanId}";
        if (kanbanId === undefined || kanbanId === null)
            throw new Error("The parameter 'kanbanId' must be defined.");
        url_ = url_.replace("{kanbanId}", encodeURIComponent("" + kanbanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecalculateRecordsStackRank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecalculateRecordsStackRank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRecalculateRecordsStackRank(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FormsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForm(formId: string | undefined): Observable<FormDto> {
        let url_ = this.baseUrl + "/api/Forms/GetForm?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormDto>;
        }));
    }

    protected processGetForm(response: HttpResponseBase): Observable<FormDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEntityDefaultForm(entityId: string | undefined): Observable<EntityDefaultFormDto> {
        let url_ = this.baseUrl + "/api/Forms/GetEntityDefaultForm?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityDefaultForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityDefaultForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityDefaultFormDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityDefaultFormDto>;
        }));
    }

    protected processGetEntityDefaultForm(response: HttpResponseBase): Observable<EntityDefaultFormDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityDefaultFormDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ContextMenuClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getContextMenu(navigationToken: string | null | undefined, type: ToolbarType | undefined): Observable<ContextMenuDto> {
        let url_ = this.baseUrl + "/api/ContextMenu/GetContextMenu?";
        if (navigationToken !== undefined && navigationToken !== null)
            url_ += "NavigationToken=" + encodeURIComponent("" + navigationToken) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContextMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContextMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContextMenuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContextMenuDto>;
        }));
    }

    protected processGetContextMenu(response: HttpResponseBase): Observable<ContextMenuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContextMenuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getViewContextMenu(viewId: string | null | undefined, type: ToolbarType | undefined): Observable<ContextMenuDto> {
        let url_ = this.baseUrl + "/api/ContextMenu/GetViewContextMenu?";
        if (viewId !== undefined && viewId !== null)
            url_ += "ViewId=" + encodeURIComponent("" + viewId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetViewContextMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViewContextMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContextMenuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContextMenuDto>;
        }));
    }

    protected processGetViewContextMenu(response: HttpResponseBase): Observable<ContextMenuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContextMenuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDialogContextMenu(formId: string | null | undefined, recordId: string | null | undefined): Observable<ContextMenuDto> {
        let url_ = this.baseUrl + "/api/ContextMenu/GetDialogContextMenu?";
        if (formId !== undefined && formId !== null)
            url_ += "FormId=" + encodeURIComponent("" + formId) + "&";
        if (recordId !== undefined && recordId !== null)
            url_ += "RecordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDialogContextMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDialogContextMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContextMenuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContextMenuDto>;
        }));
    }

    protected processGetDialogContextMenu(response: HttpResponseBase): Observable<ContextMenuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContextMenuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ExecuteBackgroundJobCommand {
    backgroundJobId?: string;

    init(_data?: any) {
        if (_data) {
            this.backgroundJobId = _data["backgroundJobId"];
        }
    }

    static fromJS(data: any): ExecuteBackgroundJobCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteBackgroundJobCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backgroundJobId"] = this.backgroundJobId;
        return data;
    }
}

export class RefreshRegistrationCommand {

    init(_data?: any) {
    }

    static fromJS(data: any): RefreshRegistrationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshRegistrationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export enum BlobType {
    Standard = 0,
    Temporary = 1,
}

export class GetPrefilledRecordQuery {
    entityName?: string | undefined;
    recordValues?: { [key: string]: any; } | undefined;

    init(_data?: any) {
        if (_data) {
            this.entityName = _data["entityName"];
            if (_data["recordValues"]) {
                this.recordValues = {} as any;
                for (let key in _data["recordValues"]) {
                    if (_data["recordValues"].hasOwnProperty(key))
                        (<any>this.recordValues)![key] = _data["recordValues"][key];
                }
            }
        }
    }

    static fromJS(data: any): GetPrefilledRecordQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrefilledRecordQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityName"] = this.entityName;
        if (this.recordValues) {
            data["recordValues"] = {};
            for (let key in this.recordValues) {
                if (this.recordValues.hasOwnProperty(key))
                    (<any>data["recordValues"])[key] = (<any>this.recordValues)[key];
            }
        }
        return data;
    }
}

export class GetMappingOperationsQueryResult {
    recordValues?: { [key: string]: any; } | undefined;
    mappingOrder?: MappingOperationFields[] | undefined;

    init(_data?: any) {
        if (_data) {
            if (_data["recordValues"]) {
                this.recordValues = {} as any;
                for (let key in _data["recordValues"]) {
                    if (_data["recordValues"].hasOwnProperty(key))
                        (<any>this.recordValues)![key] = _data["recordValues"][key];
                }
            }
            if (Array.isArray(_data["mappingOrder"])) {
                this.mappingOrder = [] as any;
                for (let item of _data["mappingOrder"])
                    this.mappingOrder!.push(MappingOperationFields.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMappingOperationsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMappingOperationsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.recordValues) {
            data["recordValues"] = {};
            for (let key in this.recordValues) {
                if (this.recordValues.hasOwnProperty(key))
                    (<any>data["recordValues"])[key] = (<any>this.recordValues)[key];
            }
        }
        if (Array.isArray(this.mappingOrder)) {
            data["mappingOrder"] = [];
            for (let item of this.mappingOrder)
                data["mappingOrder"].push(item.toJSON());
        }
        return data;
    }
}

export class MappingOperationFields {
    attributes?: string[] | undefined;
    usedMappingOperation?: MappingOperation;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(item);
            }
            this.usedMappingOperation = _data["usedMappingOperation"];
        }
    }

    static fromJS(data: any): MappingOperationFields {
        data = typeof data === 'object' ? data : {};
        let result = new MappingOperationFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item);
        }
        data["usedMappingOperation"] = this.usedMappingOperation;
        return data;
    }
}

export enum MappingOperation {
    AlwaysSet = 0,
    SetIfNull = 1,
}

export class GetMappingOperationsQuery {
    entityName?: string | undefined;
    lookupAttributeName?: string | undefined;
    formType?: FormType;
    recordValues?: { [key: string]: any; } | undefined;

    init(_data?: any) {
        if (_data) {
            this.entityName = _data["entityName"];
            this.lookupAttributeName = _data["lookupAttributeName"];
            this.formType = _data["formType"];
            if (_data["recordValues"]) {
                this.recordValues = {} as any;
                for (let key in _data["recordValues"]) {
                    if (_data["recordValues"].hasOwnProperty(key))
                        (<any>this.recordValues)![key] = _data["recordValues"][key];
                }
            }
        }
    }

    static fromJS(data: any): GetMappingOperationsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMappingOperationsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityName"] = this.entityName;
        data["lookupAttributeName"] = this.lookupAttributeName;
        data["formType"] = this.formType;
        if (this.recordValues) {
            data["recordValues"] = {};
            for (let key in this.recordValues) {
                if (this.recordValues.hasOwnProperty(key))
                    (<any>data["recordValues"])[key] = (<any>this.recordValues)[key];
            }
        }
        return data;
    }
}

export enum FormType {
    Create = 0,
    Update = 1,
}

export enum FileType {
    Csv = 0,
    Excel = 1,
}

export class LanguageDto {
    id?: string;
    code?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }
}

export class UILanguageDto {
    id?: string;
    code?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UILanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new UILanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }
}

export class UserViewSettingsNavigationInfoDto {
    entityId?: string;
    defaultFormId?: string;
    recordId?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.defaultFormId = _data["defaultFormId"];
            this.recordId = _data["recordId"];
        }
    }

    static fromJS(data: any): UserViewSettingsNavigationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewSettingsNavigationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["defaultFormId"] = this.defaultFormId;
        data["recordId"] = this.recordId;
        return data;
    }
}

export class GetNavigationTargetsQueryResult {
    navigationTargets?: { [key: string]: NavigationTargetDto; } | undefined;

    init(_data?: any) {
        if (_data) {
            if (_data["navigationTargets"]) {
                this.navigationTargets = {} as any;
                for (let key in _data["navigationTargets"]) {
                    if (_data["navigationTargets"].hasOwnProperty(key))
                        (<any>this.navigationTargets)![key] = _data["navigationTargets"][key] ? NavigationTargetDto.fromJS(_data["navigationTargets"][key]) : new NavigationTargetDto();
                }
            }
        }
    }

    static fromJS(data: any): GetNavigationTargetsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetNavigationTargetsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.navigationTargets) {
            data["navigationTargets"] = {};
            for (let key in this.navigationTargets) {
                if (this.navigationTargets.hasOwnProperty(key))
                    (<any>data["navigationTargets"])[key] = this.navigationTargets[key] ? this.navigationTargets[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export class NavigationTargetDto {
    navigationToken?: string | undefined;
    name?: string | undefined;
    entityId?: string | undefined;
    entityName?: string | undefined;
    entityType?: EntityType;
    viewId?: string | undefined;
    viewName?: string | undefined;
    kanbanId?: string | undefined;
    kanbanName?: string | undefined;
    formId?: string | undefined;
    formName?: string | undefined;
    recordId?: string | undefined;
    recordName?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.navigationToken = _data["navigationToken"];
            this.name = _data["name"];
            this.entityId = _data["entityId"];
            this.entityName = _data["entityName"];
            this.entityType = _data["entityType"];
            this.viewId = _data["viewId"];
            this.viewName = _data["viewName"];
            this.kanbanId = _data["kanbanId"];
            this.kanbanName = _data["kanbanName"];
            this.formId = _data["formId"];
            this.formName = _data["formName"];
            this.recordId = _data["recordId"];
            this.recordName = _data["recordName"];
        }
    }

    static fromJS(data: any): NavigationTargetDto {
        data = typeof data === 'object' ? data : {};
        let result = new NavigationTargetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["navigationToken"] = this.navigationToken;
        data["name"] = this.name;
        data["entityId"] = this.entityId;
        data["entityName"] = this.entityName;
        data["entityType"] = this.entityType;
        data["viewId"] = this.viewId;
        data["viewName"] = this.viewName;
        data["kanbanId"] = this.kanbanId;
        data["kanbanName"] = this.kanbanName;
        data["formId"] = this.formId;
        data["formName"] = this.formName;
        data["recordId"] = this.recordId;
        data["recordName"] = this.recordName;
        return data;
    }
}

export enum EntityType {
    Table = 0,
    View = 1,
    Virtual = 2,
}

export class CreateNavigationTargetCommand {
    routeData?: { [key: string]: string; } | undefined;

    init(_data?: any) {
        if (_data) {
            if (_data["routeData"]) {
                this.routeData = {} as any;
                for (let key in _data["routeData"]) {
                    if (_data["routeData"].hasOwnProperty(key))
                        (<any>this.routeData)![key] = _data["routeData"][key];
                }
            }
        }
    }

    static fromJS(data: any): CreateNavigationTargetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNavigationTargetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.routeData) {
            data["routeData"] = {};
            for (let key in this.routeData) {
                if (this.routeData.hasOwnProperty(key))
                    (<any>data["routeData"])[key] = (<any>this.routeData)[key];
            }
        }
        return data;
    }
}

export class CheckCurrentUserPermissionKeyResult {
    permissionKeyId?: string;
    hasPermission?: boolean;
    permissionKeyName?: string | undefined;
    permissionKeyLevel?: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.permissionKeyId = _data["permissionKeyId"];
            this.hasPermission = _data["hasPermission"];
            this.permissionKeyName = _data["permissionKeyName"];
            this.permissionKeyLevel = _data["permissionKeyLevel"];
        }
    }

    static fromJS(data: any): CheckCurrentUserPermissionKeyResult {
        data = typeof data === 'object' ? data : {};
        let result = new CheckCurrentUserPermissionKeyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionKeyId"] = this.permissionKeyId;
        data["hasPermission"] = this.hasPermission;
        data["permissionKeyName"] = this.permissionKeyName;
        data["permissionKeyLevel"] = this.permissionKeyLevel;
        return data;
    }
}

export class KeyValuePairOfStringAndObject {
    key?: string | undefined;
    value?: any | undefined;

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndObject {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export class EngineVersion {
    metadataVersion?: number;
    solutionVersion?: string | undefined;
    assemblyVersion?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.metadataVersion = _data["metadataVersion"];
            this.solutionVersion = _data["solutionVersion"];
            this.assemblyVersion = _data["assemblyVersion"];
        }
    }

    static fromJS(data: any): EngineVersion {
        data = typeof data === 'object' ? data : {};
        let result = new EngineVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadataVersion"] = this.metadataVersion;
        data["solutionVersion"] = this.solutionVersion;
        data["assemblyVersion"] = this.assemblyVersion;
        return data;
    }
}

export class UserProfileDto {
    userId?: string;
    email?: string | undefined;
    displayName?: string | undefined;
    avatar?: IconDto | undefined;
    culture?: CultureDto | undefined;
    language?: UILanguageDto | undefined;
    ianaTimeZone?: string | undefined;
    permissionKeyId?: string;
    roles?: RoleDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            this.avatar = _data["avatar"] ? IconDto.fromJS(_data["avatar"]) : <any>undefined;
            this.culture = _data["culture"] ? CultureDto.fromJS(_data["culture"]) : <any>undefined;
            this.language = _data["language"] ? UILanguageDto.fromJS(_data["language"]) : <any>undefined;
            this.ianaTimeZone = _data["ianaTimeZone"];
            this.permissionKeyId = _data["permissionKeyId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        data["avatar"] = this.avatar ? this.avatar.toJSON() : <any>undefined;
        data["culture"] = this.culture ? this.culture.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["ianaTimeZone"] = this.ianaTimeZone;
        data["permissionKeyId"] = this.permissionKeyId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export class IconDto {
    iconRelativePath?: string | undefined;
    fontIconName?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.iconRelativePath = _data["iconRelativePath"];
            this.fontIconName = _data["fontIconName"];
        }
    }

    static fromJS(data: any): IconDto {
        data = typeof data === 'object' ? data : {};
        let result = new IconDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iconRelativePath"] = this.iconRelativePath;
        data["fontIconName"] = this.fontIconName;
        return data;
    }
}

export class CultureDto {
    currencySymbol?: string | undefined;
    currencyPattern?: string | undefined;
    numberDecimalPattern?: string | undefined;
    numberDecimalSeparator?: string | undefined;
    numberGroupSeparator?: string | undefined;
    timeShortPattern?: string | undefined;
    timeLongPattern?: string | undefined;
    dateShortPattern?: string | undefined;
    dateLongPattern?: string | undefined;
    dateTimeShortPattern?: string | undefined;
    dateTimeLongPattern?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.currencySymbol = _data["currencySymbol"];
            this.currencyPattern = _data["currencyPattern"];
            this.numberDecimalPattern = _data["numberDecimalPattern"];
            this.numberDecimalSeparator = _data["numberDecimalSeparator"];
            this.numberGroupSeparator = _data["numberGroupSeparator"];
            this.timeShortPattern = _data["timeShortPattern"];
            this.timeLongPattern = _data["timeLongPattern"];
            this.dateShortPattern = _data["dateShortPattern"];
            this.dateLongPattern = _data["dateLongPattern"];
            this.dateTimeShortPattern = _data["dateTimeShortPattern"];
            this.dateTimeLongPattern = _data["dateTimeLongPattern"];
        }
    }

    static fromJS(data: any): CultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencySymbol"] = this.currencySymbol;
        data["currencyPattern"] = this.currencyPattern;
        data["numberDecimalPattern"] = this.numberDecimalPattern;
        data["numberDecimalSeparator"] = this.numberDecimalSeparator;
        data["numberGroupSeparator"] = this.numberGroupSeparator;
        data["timeShortPattern"] = this.timeShortPattern;
        data["timeLongPattern"] = this.timeLongPattern;
        data["dateShortPattern"] = this.dateShortPattern;
        data["dateLongPattern"] = this.dateLongPattern;
        data["dateTimeShortPattern"] = this.dateTimeShortPattern;
        data["dateTimeLongPattern"] = this.dateTimeLongPattern;
        return data;
    }
}

export class RoleDto {
    id?: string;
    name?: string | undefined;
    permissionKeyId?: string;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.permissionKeyId = _data["permissionKeyId"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["permissionKeyId"] = this.permissionKeyId;
        return data;
    }
}

export class SetUserViewSettingsPageSizeCommand {
    viewId?: string;
    pageSize?: number;

    init(_data?: any) {
        if (_data) {
            this.viewId = _data["viewId"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): SetUserViewSettingsPageSizeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserViewSettingsPageSizeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewId"] = this.viewId;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export class SetUserViewSettingsMainSelectorVisibilityCommand {
    viewsMainSelectorVisibility?: ViewMainSelectorVisibilityDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["viewsMainSelectorVisibility"])) {
                this.viewsMainSelectorVisibility = [] as any;
                for (let item of _data["viewsMainSelectorVisibility"])
                    this.viewsMainSelectorVisibility!.push(ViewMainSelectorVisibilityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetUserViewSettingsMainSelectorVisibilityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserViewSettingsMainSelectorVisibilityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.viewsMainSelectorVisibility)) {
            data["viewsMainSelectorVisibility"] = [];
            for (let item of this.viewsMainSelectorVisibility)
                data["viewsMainSelectorVisibility"].push(item.toJSON());
        }
        return data;
    }
}

export class ViewMainSelectorVisibilityDto {
    viewId?: string;
    isVisibleOnMainSelector?: boolean;

    init(_data?: any) {
        if (_data) {
            this.viewId = _data["viewId"];
            this.isVisibleOnMainSelector = _data["isVisibleOnMainSelector"];
        }
    }

    static fromJS(data: any): ViewMainSelectorVisibilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViewMainSelectorVisibilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewId"] = this.viewId;
        data["isVisibleOnMainSelector"] = this.isVisibleOnMainSelector;
        return data;
    }
}

export class EntityViewDto {
    view?: ViewDto | undefined;
    defaultFormId?: string;
    simpleViews?: SimpleViewDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.view = _data["view"] ? ViewDto.fromJS(_data["view"]) : <any>undefined;
            this.defaultFormId = _data["defaultFormId"];
            if (Array.isArray(_data["simpleViews"])) {
                this.simpleViews = [] as any;
                for (let item of _data["simpleViews"])
                    this.simpleViews!.push(SimpleViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["view"] = this.view ? this.view.toJSON() : <any>undefined;
        data["defaultFormId"] = this.defaultFormId;
        if (Array.isArray(this.simpleViews)) {
            data["simpleViews"] = [];
            for (let item of this.simpleViews)
                data["simpleViews"].push(item.toJSON());
        }
        return data;
    }
}

export class ViewDto {
    id?: string;
    name?: string | undefined;
    entity?: EntityWithAttributesDto | undefined;
    isDefault?: boolean;
    label?: string | undefined;
    defaultQuery?: string | undefined;
    pageSize?: number | undefined;
    columns?: ColumnDto[] | undefined;
    viewAttributes?: SelectExpandDto | undefined;
    canCreate?: boolean;
    canRead?: boolean;
    canUpdate?: boolean;
    canDelete?: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.entity = _data["entity"] ? EntityWithAttributesDto.fromJS(_data["entity"]) : <any>undefined;
            this.isDefault = _data["isDefault"];
            this.label = _data["label"];
            this.defaultQuery = _data["defaultQuery"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(ColumnDto.fromJS(item));
            }
            this.viewAttributes = _data["viewAttributes"] ? SelectExpandDto.fromJS(_data["viewAttributes"]) : <any>undefined;
            this.canCreate = _data["canCreate"];
            this.canRead = _data["canRead"];
            this.canUpdate = _data["canUpdate"];
            this.canDelete = _data["canDelete"];
        }
    }

    static fromJS(data: any): ViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["isDefault"] = this.isDefault;
        data["label"] = this.label;
        data["defaultQuery"] = this.defaultQuery;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        data["viewAttributes"] = this.viewAttributes ? this.viewAttributes.toJSON() : <any>undefined;
        data["canCreate"] = this.canCreate;
        data["canRead"] = this.canRead;
        data["canUpdate"] = this.canUpdate;
        data["canDelete"] = this.canDelete;
        return data;
    }
}

export class EntityWithAttributesDto {
    id?: string;
    name?: string | undefined;
    attributes?: AttributeDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(AttributeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityWithAttributesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityWithAttributesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        return data;
    }
}

export class AttributeDto {
    id?: string;
    name?: string | undefined;
    type?: AttributeType;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export enum AttributeType {
    None = 0,
    Boolean = 1,
    DateTime = 2,
    Decimal = 3,
    Int = 4,
    Lookup = 5,
    OptionSet = 6,
    Text = 7,
    Guid = 8,
    Binary = 9,
    TimeSpan = 10,
    Long = 11,
}

export class ColumnDto {
    id?: string;
    label?: string | undefined;
    tooltip?: string | undefined;
    primaryAttributeName?: string | undefined;
    secondaryAttributeName?: string | undefined;
    align?: AlignStyle | undefined;
    textAlign?: AlignStyle | undefined;
    dataType?: DataType | undefined;
    widthType?: WidthType | undefined;
    width?: number | undefined;
    defaultAggregator?: Aggregator | undefined;
    availableAggregators?: Aggregator[] | undefined;
    primaryEnum?: EnumDto | undefined;
    secondaryEnum?: EnumDto | undefined;
    mask?: string | undefined;
    isFreezed?: boolean | undefined;
    isEditable?: boolean;
    linkBehavior?: LinkBehavior | undefined;
    linkPlaceholder?: string | undefined;
    formatType?: DateTimeFormat | undefined;
    customFormat?: string | undefined;
    relatedEntity?: RelatedEntityDto | undefined;
    progressMinValue?: number | undefined;
    progressMaxValue?: number | undefined;
    timeMinPrecision?: TimePrecision | undefined;
    timeMaxPrecision?: TimePrecision | undefined;
    ratingMinValue?: number | undefined;
    ratingMaxValue?: number | undefined;
    iconUrl?: string | undefined;
    icon?: IconDto | undefined;
    iconType?: IconType | undefined;
    combinedTextsSeparator?: string | undefined;
    decimalPlaces?: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.tooltip = _data["tooltip"];
            this.primaryAttributeName = _data["primaryAttributeName"];
            this.secondaryAttributeName = _data["secondaryAttributeName"];
            this.align = _data["align"];
            this.textAlign = _data["textAlign"];
            this.dataType = _data["dataType"];
            this.widthType = _data["widthType"];
            this.width = _data["width"];
            this.defaultAggregator = _data["defaultAggregator"];
            if (Array.isArray(_data["availableAggregators"])) {
                this.availableAggregators = [] as any;
                for (let item of _data["availableAggregators"])
                    this.availableAggregators!.push(item);
            }
            this.primaryEnum = _data["primaryEnum"] ? EnumDto.fromJS(_data["primaryEnum"]) : <any>undefined;
            this.secondaryEnum = _data["secondaryEnum"] ? EnumDto.fromJS(_data["secondaryEnum"]) : <any>undefined;
            this.mask = _data["mask"];
            this.isFreezed = _data["isFreezed"];
            this.isEditable = _data["isEditable"];
            this.linkBehavior = _data["linkBehavior"];
            this.linkPlaceholder = _data["linkPlaceholder"];
            this.formatType = _data["formatType"];
            this.customFormat = _data["customFormat"];
            this.relatedEntity = _data["relatedEntity"] ? RelatedEntityDto.fromJS(_data["relatedEntity"]) : <any>undefined;
            this.progressMinValue = _data["progressMinValue"];
            this.progressMaxValue = _data["progressMaxValue"];
            this.timeMinPrecision = _data["timeMinPrecision"];
            this.timeMaxPrecision = _data["timeMaxPrecision"];
            this.ratingMinValue = _data["ratingMinValue"];
            this.ratingMaxValue = _data["ratingMaxValue"];
            this.iconUrl = _data["iconUrl"];
            this.icon = _data["icon"] ? IconDto.fromJS(_data["icon"]) : <any>undefined;
            this.iconType = _data["iconType"];
            this.combinedTextsSeparator = _data["combinedTextsSeparator"];
            this.decimalPlaces = _data["decimalPlaces"];
        }
    }

    static fromJS(data: any): ColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["tooltip"] = this.tooltip;
        data["primaryAttributeName"] = this.primaryAttributeName;
        data["secondaryAttributeName"] = this.secondaryAttributeName;
        data["align"] = this.align;
        data["textAlign"] = this.textAlign;
        data["dataType"] = this.dataType;
        data["widthType"] = this.widthType;
        data["width"] = this.width;
        data["defaultAggregator"] = this.defaultAggregator;
        if (Array.isArray(this.availableAggregators)) {
            data["availableAggregators"] = [];
            for (let item of this.availableAggregators)
                data["availableAggregators"].push(item);
        }
        data["primaryEnum"] = this.primaryEnum ? this.primaryEnum.toJSON() : <any>undefined;
        data["secondaryEnum"] = this.secondaryEnum ? this.secondaryEnum.toJSON() : <any>undefined;
        data["mask"] = this.mask;
        data["isFreezed"] = this.isFreezed;
        data["isEditable"] = this.isEditable;
        data["linkBehavior"] = this.linkBehavior;
        data["linkPlaceholder"] = this.linkPlaceholder;
        data["formatType"] = this.formatType;
        data["customFormat"] = this.customFormat;
        data["relatedEntity"] = this.relatedEntity ? this.relatedEntity.toJSON() : <any>undefined;
        data["progressMinValue"] = this.progressMinValue;
        data["progressMaxValue"] = this.progressMaxValue;
        data["timeMinPrecision"] = this.timeMinPrecision;
        data["timeMaxPrecision"] = this.timeMaxPrecision;
        data["ratingMinValue"] = this.ratingMinValue;
        data["ratingMaxValue"] = this.ratingMaxValue;
        data["iconUrl"] = this.iconUrl;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        data["iconType"] = this.iconType;
        data["combinedTextsSeparator"] = this.combinedTextsSeparator;
        data["decimalPlaces"] = this.decimalPlaces;
        return data;
    }
}

export enum AlignStyle {
    Left = 0,
    Right = 1,
    Center = 2,
}

export enum DataType {
    Text = 0,
    Decimal = 1,
    Guid = 2,
    DateTime = 3,
    Date = 4,
    Boolean = 5,
    Enum = 6,
    Hyperlink = 7,
    Integer = 8,
    Progress = 9,
    Time = 10,
    Rating = 11,
    Icon = 12,
    CombinedTexts = 13,
    Process = 14,
}

export enum WidthType {
    Percentage = 0,
    Pixel = 1,
    AdjustToText = 2,
    AdjustToSpace = 3,
}

export enum Aggregator {
    Sum = 0,
    Average = 1,
    Min = 2,
    Max = 3,
    Count = 4,
    CountDistinct = 5,
}

export class EnumDto {
    isFlags?: boolean;
    fullName?: string | undefined;
    options?: OptionSetValueDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.isFlags = _data["isFlags"];
            this.fullName = _data["fullName"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(OptionSetValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnumDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFlags"] = this.isFlags;
        data["fullName"] = this.fullName;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data;
    }
}

export class OptionSetValueDto {
    label?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    htmlColor?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.htmlColor = _data["htmlColor"];
        }
    }

    static fromJS(data: any): OptionSetValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionSetValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["name"] = this.name;
        data["value"] = this.value;
        data["htmlColor"] = this.htmlColor;
        return data;
    }
}

export enum LinkBehavior {
    OpenInSamePage = 0,
    OpenInNewTab = 1,
    OpenInNewWindow = 2,
    OpenInEngineContext = 3,
}

export enum DateTimeFormat {
    Short = 0,
    Long = 1,
    Custom = 2,
}

export class RelatedEntityDto {
    entityId?: string;
    defaultFormId?: string;

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.defaultFormId = _data["defaultFormId"];
        }
    }

    static fromJS(data: any): RelatedEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["defaultFormId"] = this.defaultFormId;
        return data;
    }
}

export enum TimePrecision {
    Days = 0,
    Hours = 1,
    Minutes = 2,
    Seconds = 3,
}

export enum IconType {
    Icon = 0,
    Url = 1,
}

export class SelectExpandDto {
    select?: string[] | undefined;
    expand?: { [key: string]: SelectExpandDto; } | undefined;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["select"])) {
                this.select = [] as any;
                for (let item of _data["select"])
                    this.select!.push(item);
            }
            if (_data["expand"]) {
                this.expand = {} as any;
                for (let key in _data["expand"]) {
                    if (_data["expand"].hasOwnProperty(key))
                        (<any>this.expand)![key] = _data["expand"][key] ? SelectExpandDto.fromJS(_data["expand"][key]) : new SelectExpandDto();
                }
            }
        }
    }

    static fromJS(data: any): SelectExpandDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectExpandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.select)) {
            data["select"] = [];
            for (let item of this.select)
                data["select"].push(item);
        }
        if (this.expand) {
            data["expand"] = {};
            for (let key in this.expand) {
                if (this.expand.hasOwnProperty(key))
                    (<any>data["expand"])[key] = this.expand[key] ? this.expand[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export class SimpleViewDto {
    id?: string;
    label?: string | undefined;
    viewTargets?: ViewTargets;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.viewTargets = _data["viewTargets"];
        }
    }

    static fromJS(data: any): SimpleViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["viewTargets"] = this.viewTargets;
        return data;
    }
}

export enum ViewTargets {
    Overview = 1,
    Subgrid = 2,
    Expander = 4,
}

export class ErrorHandlerDto {
    scriptRelativePath?: string | undefined;
    functionName?: string | undefined;
    exceptionName?: string | undefined;
    order?: number;

    init(_data?: any) {
        if (_data) {
            this.scriptRelativePath = _data["scriptRelativePath"];
            this.functionName = _data["functionName"];
            this.exceptionName = _data["exceptionName"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): ErrorHandlerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorHandlerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scriptRelativePath"] = this.scriptRelativePath;
        data["functionName"] = this.functionName;
        data["exceptionName"] = this.exceptionName;
        data["order"] = this.order;
        return data;
    }
}

export class ProcessStateDto {
    id?: string;
    name?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;
    isInitialState?: boolean;
    htmlColor?: string | undefined;
    entityId?: string | undefined;
    entityName?: string | undefined;
    icon?: IconDto | undefined;
    transitions?: ProcessStateTransitionDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.label = _data["label"];
            this.description = _data["description"];
            this.isInitialState = _data["isInitialState"];
            this.htmlColor = _data["htmlColor"];
            this.entityId = _data["entityId"];
            this.entityName = _data["entityName"];
            this.icon = _data["icon"] ? IconDto.fromJS(_data["icon"]) : <any>undefined;
            if (Array.isArray(_data["transitions"])) {
                this.transitions = [] as any;
                for (let item of _data["transitions"])
                    this.transitions!.push(ProcessStateTransitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["label"] = this.label;
        data["description"] = this.description;
        data["isInitialState"] = this.isInitialState;
        data["htmlColor"] = this.htmlColor;
        data["entityId"] = this.entityId;
        data["entityName"] = this.entityName;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        if (Array.isArray(this.transitions)) {
            data["transitions"] = [];
            for (let item of this.transitions)
                data["transitions"].push(item.toJSON());
        }
        return data;
    }
}

export class ProcessStateTransitionDto {
    id?: string;
    name?: string | undefined;
    label?: string | undefined;
    htmlColor?: string | undefined;
    isManual?: string | undefined;
    targetStateId?: string;
    icon?: IconDto | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.label = _data["label"];
            this.htmlColor = _data["htmlColor"];
            this.isManual = _data["isManual"];
            this.targetStateId = _data["targetStateId"];
            this.icon = _data["icon"] ? IconDto.fromJS(_data["icon"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcessStateTransitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessStateTransitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["label"] = this.label;
        data["htmlColor"] = this.htmlColor;
        data["isManual"] = this.isManual;
        data["targetStateId"] = this.targetStateId;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        return data;
    }
}

export class ProcessEntityAssignmentDto {
    id?: string | undefined;
    name?: string | undefined;
    processAssignmentId?: string | undefined;
    processDefinitionName?: string | undefined;
    internalName?: string | undefined;
    entityId?: string | undefined;
    processStateLookupAttributeId?: string | undefined;
    processStateLookupAttributeName?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.processAssignmentId = _data["processAssignmentId"];
            this.processDefinitionName = _data["processDefinitionName"];
            this.internalName = _data["internalName"];
            this.entityId = _data["entityId"];
            this.processStateLookupAttributeId = _data["processStateLookupAttributeId"];
            this.processStateLookupAttributeName = _data["processStateLookupAttributeName"];
        }
    }

    static fromJS(data: any): ProcessEntityAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessEntityAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["processAssignmentId"] = this.processAssignmentId;
        data["processDefinitionName"] = this.processDefinitionName;
        data["internalName"] = this.internalName;
        data["entityId"] = this.entityId;
        data["processStateLookupAttributeId"] = this.processStateLookupAttributeId;
        data["processStateLookupAttributeName"] = this.processStateLookupAttributeName;
        return data;
    }
}

export class ProcessExecutionResult {
    hasRecordChanged?: boolean;
    recordId?: string | undefined;
    entityId?: string | undefined;
    formId?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.hasRecordChanged = _data["hasRecordChanged"];
            this.recordId = _data["recordId"];
            this.entityId = _data["entityId"];
            this.formId = _data["formId"];
        }
    }

    static fromJS(data: any): ProcessExecutionResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessExecutionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasRecordChanged"] = this.hasRecordChanged;
        data["recordId"] = this.recordId;
        data["entityId"] = this.entityId;
        data["formId"] = this.formId;
        return data;
    }
}

export class ExecuteProcessTransitionCommand {
    targetStageId?: string;
    recordId?: string;
    attributeId?: string;

    init(_data?: any) {
        if (_data) {
            this.targetStageId = _data["targetStageId"];
            this.recordId = _data["recordId"];
            this.attributeId = _data["attributeId"];
        }
    }

    static fromJS(data: any): ExecuteProcessTransitionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteProcessTransitionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetStageId"] = this.targetStageId;
        data["recordId"] = this.recordId;
        data["attributeId"] = this.attributeId;
        return data;
    }
}

export class ProcessInstanceHistoryDto {
    id?: string;
    entityId?: string | undefined;
    entityName?: string | undefined;
    recordId?: string;
    defaultFormId?: string | undefined;
    createdOn?: moment.Moment;
    processState?: ProcessStateDto | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.entityName = _data["entityName"];
            this.recordId = _data["recordId"];
            this.defaultFormId = _data["defaultFormId"];
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>undefined;
            this.processState = _data["processState"] ? ProcessStateDto.fromJS(_data["processState"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcessInstanceHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessInstanceHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["entityName"] = this.entityName;
        data["recordId"] = this.recordId;
        data["defaultFormId"] = this.defaultFormId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["processState"] = this.processState ? this.processState.toJSON() : <any>undefined;
        return data;
    }
}

export class ResetProcessCommand {
    processAssignmentId?: string;
    recordId?: string;

    init(_data?: any) {
        if (_data) {
            this.processAssignmentId = _data["processAssignmentId"];
            this.recordId = _data["recordId"];
        }
    }

    static fromJS(data: any): ResetProcessCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetProcessCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processAssignmentId"] = this.processAssignmentId;
        data["recordId"] = this.recordId;
        return data;
    }
}

export class MainMenuDto {
    recentMenuGroup?: MenuGroupDto | undefined;
    favoriteMenuGroup?: MenuGroupDto | undefined;
    userMenuGroup?: UserMenuGroupDto | undefined;
    menuAreas?: MenuAreaDto[] | undefined;
    menuGroups?: { [key: string]: MenuGroupDto; } | undefined;
    menuItems?: { [key: string]: MenuItemDto; } | undefined;
    menuConfiguration?: MenuConfigurationDto | undefined;

    init(_data?: any) {
        if (_data) {
            this.recentMenuGroup = _data["recentMenuGroup"] ? MenuGroupDto.fromJS(_data["recentMenuGroup"]) : <any>undefined;
            this.favoriteMenuGroup = _data["favoriteMenuGroup"] ? MenuGroupDto.fromJS(_data["favoriteMenuGroup"]) : <any>undefined;
            this.userMenuGroup = _data["userMenuGroup"] ? UserMenuGroupDto.fromJS(_data["userMenuGroup"]) : <any>undefined;
            if (Array.isArray(_data["menuAreas"])) {
                this.menuAreas = [] as any;
                for (let item of _data["menuAreas"])
                    this.menuAreas!.push(MenuAreaDto.fromJS(item));
            }
            if (_data["menuGroups"]) {
                this.menuGroups = {} as any;
                for (let key in _data["menuGroups"]) {
                    if (_data["menuGroups"].hasOwnProperty(key))
                        (<any>this.menuGroups)![key] = _data["menuGroups"][key] ? MenuGroupDto.fromJS(_data["menuGroups"][key]) : new MenuGroupDto();
                }
            }
            if (_data["menuItems"]) {
                this.menuItems = {} as any;
                for (let key in _data["menuItems"]) {
                    if (_data["menuItems"].hasOwnProperty(key))
                        (<any>this.menuItems)![key] = _data["menuItems"][key] ? MenuItemDto.fromJS(_data["menuItems"][key]) : new MenuItemDto();
                }
            }
            this.menuConfiguration = _data["menuConfiguration"] ? MenuConfigurationDto.fromJS(_data["menuConfiguration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MainMenuDto {
        data = typeof data === 'object' ? data : {};
        let result = new MainMenuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recentMenuGroup"] = this.recentMenuGroup ? this.recentMenuGroup.toJSON() : <any>undefined;
        data["favoriteMenuGroup"] = this.favoriteMenuGroup ? this.favoriteMenuGroup.toJSON() : <any>undefined;
        data["userMenuGroup"] = this.userMenuGroup ? this.userMenuGroup.toJSON() : <any>undefined;
        if (Array.isArray(this.menuAreas)) {
            data["menuAreas"] = [];
            for (let item of this.menuAreas)
                data["menuAreas"].push(item.toJSON());
        }
        if (this.menuGroups) {
            data["menuGroups"] = {};
            for (let key in this.menuGroups) {
                if (this.menuGroups.hasOwnProperty(key))
                    (<any>data["menuGroups"])[key] = this.menuGroups[key] ? this.menuGroups[key].toJSON() : <any>undefined;
            }
        }
        if (this.menuItems) {
            data["menuItems"] = {};
            for (let key in this.menuItems) {
                if (this.menuItems.hasOwnProperty(key))
                    (<any>data["menuItems"])[key] = this.menuItems[key] ? this.menuItems[key].toJSON() : <any>undefined;
            }
        }
        data["menuConfiguration"] = this.menuConfiguration ? this.menuConfiguration.toJSON() : <any>undefined;
        return data;
    }
}

export class MenuGroupDto {
    id?: string;
    name?: string | undefined;
    shortLabel?: string | undefined;
    label?: string | undefined;
    icon?: IconDto | undefined;
    menuItemIds?: string[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortLabel = _data["shortLabel"];
            this.label = _data["label"];
            this.icon = _data["icon"] ? IconDto.fromJS(_data["icon"]) : <any>undefined;
            if (Array.isArray(_data["menuItemIds"])) {
                this.menuItemIds = [] as any;
                for (let item of _data["menuItemIds"])
                    this.menuItemIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MenuGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortLabel"] = this.shortLabel;
        data["label"] = this.label;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        if (Array.isArray(this.menuItemIds)) {
            data["menuItemIds"] = [];
            for (let item of this.menuItemIds)
                data["menuItemIds"].push(item);
        }
        return data;
    }
}

export class UserMenuGroupDto extends MenuGroupDto {
    logoutIcon?: IconDto | undefined;
    darkModeIcon?: IconDto | undefined;
    languageIcon?: IconDto | undefined;
    aboutIcon?: IconDto | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logoutIcon = _data["logoutIcon"] ? IconDto.fromJS(_data["logoutIcon"]) : <any>undefined;
            this.darkModeIcon = _data["darkModeIcon"] ? IconDto.fromJS(_data["darkModeIcon"]) : <any>undefined;
            this.languageIcon = _data["languageIcon"] ? IconDto.fromJS(_data["languageIcon"]) : <any>undefined;
            this.aboutIcon = _data["aboutIcon"] ? IconDto.fromJS(_data["aboutIcon"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserMenuGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserMenuGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoutIcon"] = this.logoutIcon ? this.logoutIcon.toJSON() : <any>undefined;
        data["darkModeIcon"] = this.darkModeIcon ? this.darkModeIcon.toJSON() : <any>undefined;
        data["languageIcon"] = this.languageIcon ? this.languageIcon.toJSON() : <any>undefined;
        data["aboutIcon"] = this.aboutIcon ? this.aboutIcon.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export class MenuAreaDto {
    id?: string;
    name?: string | undefined;
    shortLabel?: string | undefined;
    label?: string | undefined;
    isDefault?: boolean;
    icon?: IconDto | undefined;
    menuGroupIds?: string[] | undefined;
    homeNavigationToken?: string | undefined;
    logo?: IconDto | undefined;
    miniLogo?: IconDto | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortLabel = _data["shortLabel"];
            this.label = _data["label"];
            this.isDefault = _data["isDefault"];
            this.icon = _data["icon"] ? IconDto.fromJS(_data["icon"]) : <any>undefined;
            if (Array.isArray(_data["menuGroupIds"])) {
                this.menuGroupIds = [] as any;
                for (let item of _data["menuGroupIds"])
                    this.menuGroupIds!.push(item);
            }
            this.homeNavigationToken = _data["homeNavigationToken"];
            this.logo = _data["logo"] ? IconDto.fromJS(_data["logo"]) : <any>undefined;
            this.miniLogo = _data["miniLogo"] ? IconDto.fromJS(_data["miniLogo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MenuAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortLabel"] = this.shortLabel;
        data["label"] = this.label;
        data["isDefault"] = this.isDefault;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        if (Array.isArray(this.menuGroupIds)) {
            data["menuGroupIds"] = [];
            for (let item of this.menuGroupIds)
                data["menuGroupIds"].push(item);
        }
        data["homeNavigationToken"] = this.homeNavigationToken;
        data["logo"] = this.logo ? this.logo.toJSON() : <any>undefined;
        data["miniLogo"] = this.miniLogo ? this.miniLogo.toJSON() : <any>undefined;
        return data;
    }
}

export class MenuItemDto {
    id?: string;
    name?: string | undefined;
    shortLabel?: string | undefined;
    label?: string | undefined;
    isDefault?: boolean;
    icon?: IconDto | undefined;
    navigationToken?: string | undefined;
    uiScripts?: UIScriptDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortLabel = _data["shortLabel"];
            this.label = _data["label"];
            this.isDefault = _data["isDefault"];
            this.icon = _data["icon"] ? IconDto.fromJS(_data["icon"]) : <any>undefined;
            this.navigationToken = _data["navigationToken"];
            if (Array.isArray(_data["uiScripts"])) {
                this.uiScripts = [] as any;
                for (let item of _data["uiScripts"])
                    this.uiScripts!.push(UIScriptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortLabel"] = this.shortLabel;
        data["label"] = this.label;
        data["isDefault"] = this.isDefault;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        data["navigationToken"] = this.navigationToken;
        if (Array.isArray(this.uiScripts)) {
            data["uiScripts"] = [];
            for (let item of this.uiScripts)
                data["uiScripts"].push(item.toJSON());
        }
        return data;
    }
}

export class UIScriptDto {
    scriptRelativePath?: string | undefined;
    functionName?: string | undefined;
    eventType?: EventType;
    order?: number;

    init(_data?: any) {
        if (_data) {
            this.scriptRelativePath = _data["scriptRelativePath"];
            this.functionName = _data["functionName"];
            this.eventType = _data["eventType"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UIScriptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UIScriptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scriptRelativePath"] = this.scriptRelativePath;
        data["functionName"] = this.functionName;
        data["eventType"] = this.eventType;
        data["order"] = this.order;
        return data;
    }
}

export enum EventType {
    OnClick = 0,
    OnChanged = 1,
    OnSaving = 2,
    OnLoaded = 3,
    PreFetch = 4,
}

export class MenuConfigurationDto {
    useRecentMenuItems?: boolean;
    useFavoriteMenuItems?: boolean;
    useUserMenuItems?: boolean;
    recentMenuItemsNumber?: number;
    homeNavigationToken?: string | undefined;
    logo?: IconDto | undefined;
    miniLogo?: IconDto | undefined;

    init(_data?: any) {
        if (_data) {
            this.useRecentMenuItems = _data["useRecentMenuItems"];
            this.useFavoriteMenuItems = _data["useFavoriteMenuItems"];
            this.useUserMenuItems = _data["useUserMenuItems"];
            this.recentMenuItemsNumber = _data["recentMenuItemsNumber"];
            this.homeNavigationToken = _data["homeNavigationToken"];
            this.logo = _data["logo"] ? IconDto.fromJS(_data["logo"]) : <any>undefined;
            this.miniLogo = _data["miniLogo"] ? IconDto.fromJS(_data["miniLogo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MenuConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useRecentMenuItems"] = this.useRecentMenuItems;
        data["useFavoriteMenuItems"] = this.useFavoriteMenuItems;
        data["useUserMenuItems"] = this.useUserMenuItems;
        data["recentMenuItemsNumber"] = this.recentMenuItemsNumber;
        data["homeNavigationToken"] = this.homeNavigationToken;
        data["logo"] = this.logo ? this.logo.toJSON() : <any>undefined;
        data["miniLogo"] = this.miniLogo ? this.miniLogo.toJSON() : <any>undefined;
        return data;
    }
}

export class AddMenuItemToFavoriteCommand {
    menuItemId?: string;

    init(_data?: any) {
        if (_data) {
            this.menuItemId = _data["menuItemId"];
        }
    }

    static fromJS(data: any): AddMenuItemToFavoriteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddMenuItemToFavoriteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItemId"] = this.menuItemId;
        return data;
    }
}

export class AddMenuItemToRecentCommand {
    menuItemId?: string;

    init(_data?: any) {
        if (_data) {
            this.menuItemId = _data["menuItemId"];
        }
    }

    static fromJS(data: any): AddMenuItemToRecentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddMenuItemToRecentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItemId"] = this.menuItemId;
        return data;
    }
}

export class RemoveMenuItemFromFavoriteCommand {
    menuItemId?: string;

    init(_data?: any) {
        if (_data) {
            this.menuItemId = _data["menuItemId"];
        }
    }

    static fromJS(data: any): RemoveMenuItemFromFavoriteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveMenuItemFromFavoriteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuItemId"] = this.menuItemId;
        return data;
    }
}

export class RecordDto {
    id?: string;
    name?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export class KanbanDto extends RecordDto {
    label?: string | undefined;
    query?: string | undefined;
    entity?: RecordDto | undefined;
    relatedAttribute?: AttributeDto2 | undefined;
    stackRankAttribute?: AttributeDto2 | undefined;
    formId?: string | undefined;
    kanbanAttributes?: SelectExpandDto | undefined;
    columns?: KanbanColumnDto[] | undefined;
    controls?: KanbanControlDto[] | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.label = _data["label"];
            this.query = _data["query"];
            this.entity = _data["entity"] ? RecordDto.fromJS(_data["entity"]) : <any>undefined;
            this.relatedAttribute = _data["relatedAttribute"] ? AttributeDto2.fromJS(_data["relatedAttribute"]) : <any>undefined;
            this.stackRankAttribute = _data["stackRankAttribute"] ? AttributeDto2.fromJS(_data["stackRankAttribute"]) : <any>undefined;
            this.formId = _data["formId"];
            this.kanbanAttributes = _data["kanbanAttributes"] ? SelectExpandDto.fromJS(_data["kanbanAttributes"]) : <any>undefined;
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(KanbanColumnDto.fromJS(item));
            }
            if (Array.isArray(_data["controls"])) {
                this.controls = [] as any;
                for (let item of _data["controls"])
                    this.controls!.push(KanbanControlDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KanbanDto {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["query"] = this.query;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["relatedAttribute"] = this.relatedAttribute ? this.relatedAttribute.toJSON() : <any>undefined;
        data["stackRankAttribute"] = this.stackRankAttribute ? this.stackRankAttribute.toJSON() : <any>undefined;
        data["formId"] = this.formId;
        data["kanbanAttributes"] = this.kanbanAttributes ? this.kanbanAttributes.toJSON() : <any>undefined;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.controls)) {
            data["controls"] = [];
            for (let item of this.controls)
                data["controls"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export class AttributeDto2 extends RecordDto {
    type?: AttributeType;
    logicalName?: string | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.logicalName = _data["logicalName"];
        }
    }

    static fromJS(data: any): AttributeDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["logicalName"] = this.logicalName;
        super.toJSON(data);
        return data;
    }
}

export class KanbanColumnDto extends RecordDto {
    relatedValue?: any | undefined;
    order?: number;
    pageSize?: number;
    kanbanId?: string;
    label?: string | undefined;
    tooltip?: string | undefined;
    htmlColor?: string | undefined;
    isDefaultMinimalized?: boolean;
    aggregators?: KanbanColumnAggregatorDto[] | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.relatedValue = _data["relatedValue"];
            this.order = _data["order"];
            this.pageSize = _data["pageSize"];
            this.kanbanId = _data["kanbanId"];
            this.label = _data["label"];
            this.tooltip = _data["tooltip"];
            this.htmlColor = _data["htmlColor"];
            this.isDefaultMinimalized = _data["isDefaultMinimalized"];
            if (Array.isArray(_data["aggregators"])) {
                this.aggregators = [] as any;
                for (let item of _data["aggregators"])
                    this.aggregators!.push(KanbanColumnAggregatorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KanbanColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relatedValue"] = this.relatedValue;
        data["order"] = this.order;
        data["pageSize"] = this.pageSize;
        data["kanbanId"] = this.kanbanId;
        data["label"] = this.label;
        data["tooltip"] = this.tooltip;
        data["htmlColor"] = this.htmlColor;
        data["isDefaultMinimalized"] = this.isDefaultMinimalized;
        if (Array.isArray(this.aggregators)) {
            data["aggregators"] = [];
            for (let item of this.aggregators)
                data["aggregators"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export class KanbanColumnAggregatorDto extends RecordDto {
    attribute?: AttributeDto2 | undefined;
    aggregator?: Aggregator;
    label?: string | undefined;
    tooltip?: string | undefined;
    order?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.attribute = _data["attribute"] ? AttributeDto2.fromJS(_data["attribute"]) : <any>undefined;
            this.aggregator = _data["aggregator"];
            this.label = _data["label"];
            this.tooltip = _data["tooltip"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): KanbanColumnAggregatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanColumnAggregatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute ? this.attribute.toJSON() : <any>undefined;
        data["aggregator"] = this.aggregator;
        data["label"] = this.label;
        data["tooltip"] = this.tooltip;
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }
}

export class KanbanControlDto extends RecordDto {
    attribute?: AttributeDto2 | undefined;
    attributePath?: string | undefined;
    label?: string | undefined;
    order?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.attribute = _data["attribute"] ? AttributeDto2.fromJS(_data["attribute"]) : <any>undefined;
            this.attributePath = _data["attributePath"];
            this.label = _data["label"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): KanbanControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new KanbanControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute ? this.attribute.toJSON() : <any>undefined;
        data["attributePath"] = this.attributePath;
        data["label"] = this.label;
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }
}

export class FormDto {
    id?: string;
    name?: string | undefined;
    entityName?: string | undefined;
    tabs?: FormTabDto[] | undefined;
    uiScripts?: UIScriptDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.entityName = _data["entityName"];
            if (Array.isArray(_data["tabs"])) {
                this.tabs = [] as any;
                for (let item of _data["tabs"])
                    this.tabs!.push(FormTabDto.fromJS(item));
            }
            if (Array.isArray(_data["uiScripts"])) {
                this.uiScripts = [] as any;
                for (let item of _data["uiScripts"])
                    this.uiScripts!.push(UIScriptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["entityName"] = this.entityName;
        if (Array.isArray(this.tabs)) {
            data["tabs"] = [];
            for (let item of this.tabs)
                data["tabs"].push(item.toJSON());
        }
        if (Array.isArray(this.uiScripts)) {
            data["uiScripts"] = [];
            for (let item of this.uiScripts)
                data["uiScripts"].push(item.toJSON());
        }
        return data;
    }
}

export class FormTabDto {
    id?: string;
    name?: string | undefined;
    title?: string | undefined;
    layoutGrid?: any | undefined;
    order?: number;
    isVisible?: boolean;
    controlGroups?: ControlGroupDto[] | undefined;
    formSections?: FormSectionDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.layoutGrid = _data["layoutGrid"];
            this.order = _data["order"];
            this.isVisible = _data["isVisible"];
            if (Array.isArray(_data["controlGroups"])) {
                this.controlGroups = [] as any;
                for (let item of _data["controlGroups"])
                    this.controlGroups!.push(ControlGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["formSections"])) {
                this.formSections = [] as any;
                for (let item of _data["formSections"])
                    this.formSections!.push(FormSectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormTabDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormTabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["title"] = this.title;
        data["layoutGrid"] = this.layoutGrid;
        data["order"] = this.order;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.controlGroups)) {
            data["controlGroups"] = [];
            for (let item of this.controlGroups)
                data["controlGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.formSections)) {
            data["formSections"] = [];
            for (let item of this.formSections)
                data["formSections"].push(item.toJSON());
        }
        return data;
    }
}

export class ControlGroupDto {
    id?: string;
    name?: string | undefined;
    tabId?: string;
    title?: string | undefined;
    subtitle?: string | undefined;
    order?: number;
    containerId?: string | undefined;
    icon?: IconDto | undefined;
    controls?: ControlDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.tabId = _data["tabId"];
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.order = _data["order"];
            this.containerId = _data["containerId"];
            this.icon = _data["icon"] ? IconDto.fromJS(_data["icon"]) : <any>undefined;
            if (Array.isArray(_data["controls"])) {
                this.controls = [] as any;
                for (let item of _data["controls"])
                    this.controls!.push(ControlDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ControlGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControlGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["tabId"] = this.tabId;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["order"] = this.order;
        data["containerId"] = this.containerId;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        if (Array.isArray(this.controls)) {
            data["controls"] = [];
            for (let item of this.controls)
                data["controls"].push(item.toJSON());
        }
        return data;
    }
}

export class ControlDto {
    id?: string;
    name?: string | undefined;
    label?: string | undefined;
    displayMode?: DisplayMode;
    isReadOnly?: boolean;
    isRequired?: boolean;
    isVisible?: boolean;
    width?: number | undefined;
    widthType?: WidthType | undefined;
    align?: AlignStyle | undefined;
    textAlign?: AlignStyle | undefined;
    type?: string | undefined;
    order?: number;
    primaryAttribute?: string | undefined;
    secondaryAttribute?: string | undefined;
    uiScripts?: UIScriptDto[] | undefined;

    protected _discriminator: string;

    constructor() {
        this._discriminator = "ControlDto";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.label = _data["label"];
            this.displayMode = _data["displayMode"];
            this.isReadOnly = _data["isReadOnly"];
            this.isRequired = _data["isRequired"];
            this.isVisible = _data["isVisible"];
            this.width = _data["width"];
            this.widthType = _data["widthType"];
            this.align = _data["align"];
            this.textAlign = _data["textAlign"];
            this.type = _data["type"];
            this.order = _data["order"];
            this.primaryAttribute = _data["primaryAttribute"];
            this.secondaryAttribute = _data["secondaryAttribute"];
            if (Array.isArray(_data["uiScripts"])) {
                this.uiScripts = [] as any;
                for (let item of _data["uiScripts"])
                    this.uiScripts!.push(UIScriptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ControlDto {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "TextControlDto") {
            let result = new TextControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "NumberControlDto") {
            let result = new NumberControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LabelControlDto") {
            let result = new LabelControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateControlDto") {
            let result = new DateControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateTimeControlDto") {
            let result = new DateTimeControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "TimeControlDto") {
            let result = new TimeControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "YesNoControlDto") {
            let result = new YesNoControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "TextAreaControlDto") {
            let result = new TextAreaControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LookupControlDto") {
            let result = new LookupControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FileUploaderControlDto") {
            let result = new FileUploaderControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "OptionSetControlDto") {
            let result = new OptionSetControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "MultiselectOptionSetControlDto") {
            let result = new MultiselectOptionSetControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SubGridControlDto") {
            let result = new SubGridControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ButtonControlDto") {
            let result = new ButtonControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HyperlinkControlDto") {
            let result = new HyperlinkControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DescriptionControlDto") {
            let result = new DescriptionControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "IconControlDto") {
            let result = new IconControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ChartControlDto") {
            let result = new ChartControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "InlineRelationControlDto") {
            let result = new InlineRelationControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HtmlEditorControlDto") {
            let result = new HtmlEditorControlDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "CombinedLookupsControlDto") {
            let result = new CombinedLookupsControlDto();
            result.init(data);
            return result;
        }
        let result = new ControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["id"] = this.id;
        data["name"] = this.name;
        data["label"] = this.label;
        data["displayMode"] = this.displayMode;
        data["isReadOnly"] = this.isReadOnly;
        data["isRequired"] = this.isRequired;
        data["isVisible"] = this.isVisible;
        data["width"] = this.width;
        data["widthType"] = this.widthType;
        data["align"] = this.align;
        data["textAlign"] = this.textAlign;
        data["type"] = this.type;
        data["order"] = this.order;
        data["primaryAttribute"] = this.primaryAttribute;
        data["secondaryAttribute"] = this.secondaryAttribute;
        if (Array.isArray(this.uiScripts)) {
            data["uiScripts"] = [];
            for (let item of this.uiScripts)
                data["uiScripts"].push(item.toJSON());
        }
        return data;
    }
}

export enum DisplayMode {
    Default = 0,
    Text = 1,
}

export class TextControlDto extends ControlDto {
    minLength?: number | undefined;
    maxLength?: number | undefined;

    constructor() {
        super();
        this._discriminator = "TextControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minLength = _data["minLength"];
            this.maxLength = _data["maxLength"];
        }
    }

    static fromJS(data: any): TextControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minLength"] = this.minLength;
        data["maxLength"] = this.maxLength;
        super.toJSON(data);
        return data;
    }
}

export class NumberControlDto extends ControlDto {
    minValue?: number | undefined;
    maxValue?: number | undefined;
    defaultValue?: number | undefined;
    onlyIntegers?: boolean | undefined;

    constructor() {
        super();
        this._discriminator = "NumberControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.defaultValue = _data["defaultValue"];
            this.onlyIntegers = _data["onlyIntegers"];
        }
    }

    static fromJS(data: any): NumberControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new NumberControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["defaultValue"] = this.defaultValue;
        data["onlyIntegers"] = this.onlyIntegers;
        super.toJSON(data);
        return data;
    }
}

export class LabelControlDto extends ControlDto {
    value?: string | undefined;

    constructor() {
        super();
        this._discriminator = "LabelControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LabelControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabelControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export class DateControlDto extends ControlDto {
    maxValue?: moment.Moment | undefined;
    minValue?: moment.Moment | undefined;
    formatType?: DateTimeFormat | undefined;
    customFormat?: string | undefined;

    constructor() {
        super();
        this._discriminator = "DateControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.maxValue = _data["maxValue"] ? moment(_data["maxValue"].toString()) : <any>undefined;
            this.minValue = _data["minValue"] ? moment(_data["minValue"].toString()) : <any>undefined;
            this.formatType = _data["formatType"];
            this.customFormat = _data["customFormat"];
        }
    }

    static fromJS(data: any): DateControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxValue"] = this.maxValue ? this.maxValue.toISOString() : <any>undefined;
        data["minValue"] = this.minValue ? this.minValue.toISOString() : <any>undefined;
        data["formatType"] = this.formatType;
        data["customFormat"] = this.customFormat;
        super.toJSON(data);
        return data;
    }
}

export class DateTimeControlDto extends ControlDto {
    maxValue?: moment.Moment | undefined;
    minValue?: moment.Moment | undefined;
    formatType?: DateTimeFormat | undefined;
    customFormat?: string | undefined;

    constructor() {
        super();
        this._discriminator = "DateTimeControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.maxValue = _data["maxValue"] ? moment(_data["maxValue"].toString()) : <any>undefined;
            this.minValue = _data["minValue"] ? moment(_data["minValue"].toString()) : <any>undefined;
            this.formatType = _data["formatType"];
            this.customFormat = _data["customFormat"];
        }
    }

    static fromJS(data: any): DateTimeControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxValue"] = this.maxValue ? this.maxValue.toISOString() : <any>undefined;
        data["minValue"] = this.minValue ? this.minValue.toISOString() : <any>undefined;
        data["formatType"] = this.formatType;
        data["customFormat"] = this.customFormat;
        super.toJSON(data);
        return data;
    }
}

export class TimeControlDto extends ControlDto {
    interval?: number | undefined;
    defaultValue?: string | undefined;
    maxPrecision?: TimePrecision | undefined;
    minPrecision?: TimePrecision | undefined;

    constructor() {
        super();
        this._discriminator = "TimeControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.interval = _data["interval"];
            this.defaultValue = _data["defaultValue"];
            this.maxPrecision = _data["maxPrecision"];
            this.minPrecision = _data["minPrecision"];
        }
    }

    static fromJS(data: any): TimeControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interval"] = this.interval;
        data["defaultValue"] = this.defaultValue;
        data["maxPrecision"] = this.maxPrecision;
        data["minPrecision"] = this.minPrecision;
        super.toJSON(data);
        return data;
    }
}

export class YesNoControlDto extends ControlDto {

    constructor() {
        super();
        this._discriminator = "YesNoControlDto";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): YesNoControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new YesNoControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export class TextAreaControlDto extends ControlDto {
    minRowsNumber?: number | undefined;
    maxRowsNumber?: number | undefined;

    constructor() {
        super();
        this._discriminator = "TextAreaControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minRowsNumber = _data["minRowsNumber"];
            this.maxRowsNumber = _data["maxRowsNumber"];
        }
    }

    static fromJS(data: any): TextAreaControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextAreaControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minRowsNumber"] = this.minRowsNumber;
        data["maxRowsNumber"] = this.maxRowsNumber;
        super.toJSON(data);
        return data;
    }
}

export class LookupControlDto extends ControlDto {
    targetEntity?: EntityWithPermissionsDto | undefined;
    showField?: string | undefined;
    expanderViewId?: string | undefined;
    formId?: string | undefined;
    isCreateButtonHiddenByCustomization?: boolean;
    isOpenButtonHiddenByCustomization?: boolean;
    isCreateButtonVisible?: boolean;
    isOpenButtonVisible?: boolean;

    constructor() {
        super();
        this._discriminator = "LookupControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.targetEntity = _data["targetEntity"] ? EntityWithPermissionsDto.fromJS(_data["targetEntity"]) : <any>undefined;
            this.showField = _data["showField"];
            this.expanderViewId = _data["expanderViewId"];
            this.formId = _data["formId"];
            this.isCreateButtonHiddenByCustomization = _data["isCreateButtonHiddenByCustomization"];
            this.isOpenButtonHiddenByCustomization = _data["isOpenButtonHiddenByCustomization"];
            this.isCreateButtonVisible = _data["isCreateButtonVisible"];
            this.isOpenButtonVisible = _data["isOpenButtonVisible"];
        }
    }

    static fromJS(data: any): LookupControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetEntity"] = this.targetEntity ? this.targetEntity.toJSON() : <any>undefined;
        data["showField"] = this.showField;
        data["expanderViewId"] = this.expanderViewId;
        data["formId"] = this.formId;
        data["isCreateButtonHiddenByCustomization"] = this.isCreateButtonHiddenByCustomization;
        data["isOpenButtonHiddenByCustomization"] = this.isOpenButtonHiddenByCustomization;
        data["isCreateButtonVisible"] = this.isCreateButtonVisible;
        data["isOpenButtonVisible"] = this.isOpenButtonVisible;
        super.toJSON(data);
        return data;
    }
}

export class EntityWithPermissionsDto extends RecordDto {
    canCreate?: boolean;
    canRead?: boolean;
    canUpdate?: boolean;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.canCreate = _data["canCreate"];
            this.canRead = _data["canRead"];
            this.canUpdate = _data["canUpdate"];
        }
    }

    static fromJS(data: any): EntityWithPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityWithPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canCreate"] = this.canCreate;
        data["canRead"] = this.canRead;
        data["canUpdate"] = this.canUpdate;
        super.toJSON(data);
        return data;
    }
}

export class FileUploaderControlDto extends ControlDto {

    constructor() {
        super();
        this._discriminator = "FileUploaderControlDto";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): FileUploaderControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploaderControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export class OptionSetControlDto extends ControlDto {
    options?: OptionSetValueDto[] | undefined;
    isFlags?: boolean;

    constructor() {
        super();
        this._discriminator = "OptionSetControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(OptionSetValueDto.fromJS(item));
            }
            this.isFlags = _data["isFlags"];
        }
    }

    static fromJS(data: any): OptionSetControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionSetControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["isFlags"] = this.isFlags;
        super.toJSON(data);
        return data;
    }
}

export class MultiselectOptionSetControlDto extends ControlDto {
    options?: OptionSetValueDto[] | undefined;

    constructor() {
        super();
        this._discriminator = "MultiselectOptionSetControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(OptionSetValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MultiselectOptionSetControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiselectOptionSetControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export class SubGridControlDto extends ControlDto {
    viewId?: string;
    displayRows?: number | undefined;
    pageSize?: number | undefined;

    constructor() {
        super();
        this._discriminator = "SubGridControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.viewId = _data["viewId"];
            this.displayRows = _data["displayRows"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): SubGridControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubGridControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewId"] = this.viewId;
        data["displayRows"] = this.displayRows;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

export class ButtonControlDto extends ControlDto {
    tooltipText?: string | undefined;
    icon?: IconDto | undefined;

    constructor() {
        super();
        this._discriminator = "ButtonControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tooltipText = _data["tooltipText"];
            this.icon = _data["icon"] ? IconDto.fromJS(_data["icon"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ButtonControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new ButtonControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tooltipText"] = this.tooltipText;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export class HyperlinkControlDto extends ControlDto {
    linkBehavior?: LinkBehavior;

    constructor() {
        super();
        this._discriminator = "HyperlinkControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkBehavior = _data["linkBehavior"];
        }
    }

    static fromJS(data: any): HyperlinkControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new HyperlinkControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkBehavior"] = this.linkBehavior;
        super.toJSON(data);
        return data;
    }
}

export class DescriptionControlDto extends ControlDto {
    value?: string | undefined;

    constructor() {
        super();
        this._discriminator = "DescriptionControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DescriptionControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new DescriptionControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export class IconControlDto extends ControlDto {
    url?: string | undefined;
    icon?: IconDto | undefined;
    iconType?: IconType;

    constructor() {
        super();
        this._discriminator = "IconControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.url = _data["url"];
            this.icon = _data["icon"] ? IconDto.fromJS(_data["icon"]) : <any>undefined;
            this.iconType = _data["iconType"];
        }
    }

    static fromJS(data: any): IconControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new IconControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        data["iconType"] = this.iconType;
        super.toJSON(data);
        return data;
    }
}

export class ChartControlDto extends ControlDto {

    constructor() {
        super();
        this._discriminator = "ChartControlDto";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ChartControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export class InlineRelationControlDto extends ControlDto {
    relationId?: string;
    sourceEntity?: EntityWithPermissionsDto | undefined;
    sourceAttributeName?: string | undefined;
    formId?: string | undefined;
    isCreateButtonHidden?: boolean;

    constructor() {
        super();
        this._discriminator = "InlineRelationControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.relationId = _data["relationId"];
            this.sourceEntity = _data["sourceEntity"] ? EntityWithPermissionsDto.fromJS(_data["sourceEntity"]) : <any>undefined;
            this.sourceAttributeName = _data["sourceAttributeName"];
            this.formId = _data["formId"];
            this.isCreateButtonHidden = _data["isCreateButtonHidden"];
        }
    }

    static fromJS(data: any): InlineRelationControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new InlineRelationControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relationId"] = this.relationId;
        data["sourceEntity"] = this.sourceEntity ? this.sourceEntity.toJSON() : <any>undefined;
        data["sourceAttributeName"] = this.sourceAttributeName;
        data["formId"] = this.formId;
        data["isCreateButtonHidden"] = this.isCreateButtonHidden;
        super.toJSON(data);
        return data;
    }
}

export class HtmlEditorControlDto extends ControlDto {

    constructor() {
        super();
        this._discriminator = "HtmlEditorControlDto";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): HtmlEditorControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlEditorControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export class CombinedLookupsControlDto extends ControlDto {
    combinedLookups?: CombinedLookupDto[] | undefined;

    constructor() {
        super();
        this._discriminator = "CombinedLookupsControlDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["combinedLookups"])) {
                this.combinedLookups = [] as any;
                for (let item of _data["combinedLookups"])
                    this.combinedLookups!.push(CombinedLookupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CombinedLookupsControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new CombinedLookupsControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.combinedLookups)) {
            data["combinedLookups"] = [];
            for (let item of this.combinedLookups)
                data["combinedLookups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export class CombinedLookupDto {
    attributeName?: string | undefined;
    targetEntity?: EntityWithPermissionsDto | undefined;
    showField?: string | undefined;
    expanderViewId?: string | undefined;
    formId?: string | undefined;
    isCreateButtonVisible?: boolean;
    isOpenButtonVisible?: boolean;

    init(_data?: any) {
        if (_data) {
            this.attributeName = _data["attributeName"];
            this.targetEntity = _data["targetEntity"] ? EntityWithPermissionsDto.fromJS(_data["targetEntity"]) : <any>undefined;
            this.showField = _data["showField"];
            this.expanderViewId = _data["expanderViewId"];
            this.formId = _data["formId"];
            this.isCreateButtonVisible = _data["isCreateButtonVisible"];
            this.isOpenButtonVisible = _data["isOpenButtonVisible"];
        }
    }

    static fromJS(data: any): CombinedLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CombinedLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeName"] = this.attributeName;
        data["targetEntity"] = this.targetEntity ? this.targetEntity.toJSON() : <any>undefined;
        data["showField"] = this.showField;
        data["expanderViewId"] = this.expanderViewId;
        data["formId"] = this.formId;
        data["isCreateButtonVisible"] = this.isCreateButtonVisible;
        data["isOpenButtonVisible"] = this.isOpenButtonVisible;
        return data;
    }
}

export class FormSectionDto {
    id?: string;
    name?: string | undefined;
    title?: string | undefined;
    subtitle?: string | undefined;
    isOutlined?: boolean;
    isVisible?: boolean;
    icon?: IconDto | undefined;
    backgroundColor?: string | undefined;
    containerId?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.isOutlined = _data["isOutlined"];
            this.isVisible = _data["isVisible"];
            this.icon = _data["icon"] ? IconDto.fromJS(_data["icon"]) : <any>undefined;
            this.backgroundColor = _data["backgroundColor"];
            this.containerId = _data["containerId"];
        }
    }

    static fromJS(data: any): FormSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["isOutlined"] = this.isOutlined;
        data["isVisible"] = this.isVisible;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        data["backgroundColor"] = this.backgroundColor;
        data["containerId"] = this.containerId;
        return data;
    }
}

export class EntityDefaultFormDto {
    id?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDefaultFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDefaultFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export class ContextMenuDto {
    useDivider?: boolean;
    sections?: SectionDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.useDivider = _data["useDivider"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContextMenuDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContextMenuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useDivider"] = this.useDivider;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        return data;
    }
}

export class SectionDto {
    id?: string;
    shortName?: string | undefined;
    icon?: IconDto | undefined;
    order?: number;
    isExpandable?: boolean;
    isHighlighted?: boolean;
    buttons?: ButtonDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortName = _data["shortName"];
            this.icon = _data["icon"] ? IconDto.fromJS(_data["icon"]) : <any>undefined;
            this.order = _data["order"];
            this.isExpandable = _data["isExpandable"];
            this.isHighlighted = _data["isHighlighted"];
            if (Array.isArray(_data["buttons"])) {
                this.buttons = [] as any;
                for (let item of _data["buttons"])
                    this.buttons!.push(ButtonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortName"] = this.shortName;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        data["order"] = this.order;
        data["isExpandable"] = this.isExpandable;
        data["isHighlighted"] = this.isHighlighted;
        if (Array.isArray(this.buttons)) {
            data["buttons"] = [];
            for (let item of this.buttons)
                data["buttons"].push(item.toJSON());
        }
        return data;
    }
}

export class ButtonDto {
    id?: string;
    icon?: IconDto | undefined;
    name?: string | undefined;
    label?: string | undefined;
    tooltipText?: string | undefined;
    order?: number;
    isHidden?: boolean;
    isHighlighted?: boolean;
    uiScripts?: UIScriptDto[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.icon = _data["icon"] ? IconDto.fromJS(_data["icon"]) : <any>undefined;
            this.name = _data["name"];
            this.label = _data["label"];
            this.tooltipText = _data["tooltipText"];
            this.order = _data["order"];
            this.isHidden = _data["isHidden"];
            this.isHighlighted = _data["isHighlighted"];
            if (Array.isArray(_data["uiScripts"])) {
                this.uiScripts = [] as any;
                for (let item of _data["uiScripts"])
                    this.uiScripts!.push(UIScriptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ButtonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ButtonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["label"] = this.label;
        data["tooltipText"] = this.tooltipText;
        data["order"] = this.order;
        data["isHidden"] = this.isHidden;
        data["isHighlighted"] = this.isHighlighted;
        if (Array.isArray(this.uiScripts)) {
            data["uiScripts"] = [];
            for (let item of this.uiScripts)
                data["uiScripts"].push(item.toJSON());
        }
        return data;
    }
}

export enum ToolbarType {
    Main = 0,
    GridColumn = 1,
    SubGrid = 2,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}